__turbopack_context__.v({
  "base": "styles-module__eiJETG__base",
  "checklist": "styles-module__eiJETG__checklist",
  "editorContainer": "styles-module__eiJETG__editorContainer",
  "inlineImage": "styles-module__eiJETG__inlineImage",
  "link": "styles-module__eiJETG__link",
  "listItemChecked": "styles-module__eiJETG__listItemChecked",
  "listItemUnchecked": "styles-module__eiJETG__listItemUnchecked",
  "nestedListItem": "styles-module__eiJETG__nestedListItem",
  "strikethrough": "styles-module__eiJETG__strikethrough",
  "table": "styles-module__eiJETG__table",
  "tableCell": "styles-module__eiJETG__tableCell",
  "tableCellHeader": "styles-module__eiJETG__tableCellHeader",
  "tableCellResizer": "styles-module__eiJETG__tableCellResizer",
  "tableCellSelected": "styles-module__eiJETG__tableCellSelected",
  "tableScrollableWrapper": "styles-module__eiJETG__tableScrollableWrapper",
  "tableSelected": "styles-module__eiJETG__tableSelected",
  "tableSelection": "styles-module__eiJETG__tableSelection",
  "underline": "styles-module__eiJETG__underline",
  "underlineStrikethrough": "styles-module__eiJETG__underlineStrikethrough",
  "variables": "styles-module__eiJETG__variables",
});
